'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright 2017, IOOF Holdings Limited.
                                                                                                                                                                                                                                                                   * All rights reserved.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _lodash = require('lodash.set');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.mergewith');

var _lodash4 = _interopRequireDefault(_lodash3);

var _redux = require('redux');

var _reduxConcatenateReducers = require('redux-concatenate-reducers');

var _reduxConcatenateReducers2 = _interopRequireDefault(_reduxConcatenateReducers);

var _filteredReducer = require('./filteredReducer');

var _filteredReducer2 = _interopRequireDefault(_filteredReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createDynamicReducer = function createDynamicReducer(reducers) {
  if (typeof reducers === 'function') {
    return (0, _filteredReducer2.default)(reducers);
  }

  var expandedReducers = Object.keys(reducers).reduce(function (currentReducers, key) {
    var reducerMap = (0, _lodash2.default)({}, key, reducers[key]);

    return (0, _lodash4.default)(currentReducers, reducerMap, function (originalReducer, newReducer) {
      return originalReducer ? (0, _reduxConcatenateReducers2.default)([createDynamicReducer(originalReducer), createDynamicReducer(newReducer)]) : newReducer;
    });
  }, {});

  var flattenedReducers = Object.keys(expandedReducers).reduce(function (currentReducers, key) {
    return _extends({}, currentReducers, _defineProperty({}, key, createDynamicReducer(expandedReducers[key])));
  }, {});

  return (0, _filteredReducer2.default)((0, _redux.combineReducers)(flattenedReducers));
};

exports.default = createDynamicReducer;